import React from "react";
import {useAxiosSetup} from "./Api";
import {useAppData} from "./AppDataContext";

function VersionInfo(props) {
    const api = useAxiosSetup();
    const [versionInfo, setVersionInfo] = React.useState(null);
    const {appData, updateAppData} = useAppData();

    React.useEffect(() => {
            api.get("/configuration/version_info/").then((response) => {
                    let versions = JSON.parse(response.data.serialized_data.VersionInfo).Versions
                    Object.keys(versions).forEach(key => {
                        versions[key] = versions[key].split(',').map(num => parseInt(num));
                    });
                    setVersionInfo(versions)
                }
            )
        }, []
    )

    // React.useEffect(() => {
    //         if (versionInfo) {
    //             const data = {"version": Object.keys(versionInfo)[0]}
    //             updateAppData({...appData, userVersionUpToDate: true})
    //             api.post("/configuration/update_user_version/", data).then((response) => {
    //                 }
    //             )
    //         }
    //     }, [versionInfo]
    // )

    return (
        <div>
            {
                versionInfo &&
                Object.entries(versionInfo).map(([key, values]) => (
                    <p>{`${key}:  `}
                        {values.map(value => (
                            <a href={`https://berko.atlassian.net/jira/software/projects/SER/issues/SER-${value}`}>SER-{value} </a>
                        ))
                        }
                    </p>
                ))
            }
        </div>
    )
}

export default VersionInfo
